import React, { useState, useContext, useEffect } from 'react';
import Button from '../claim/button';
import { useNavigate, useLocation } from 'react-router-dom';
import { ButtonSpinner } from '../../components/Spinner';
import 'cropperjs/dist/cropper.css';
import { VehicleDataContext } from '../../Context/VehicleDataContext';
import { UserContext } from '../../Context/UserContext';
import { jwtToken } from '../../Context/DataContext';
import { FiUpload } from 'react-icons/fi';
import MultipleImageUpload from '../../components/MultipleImageUpload';
import axios from 'axios';
import { showAlert } from '../../utils/AlertUtills';
import '../CSS/Steps.css';

export default function Steptwo() {
  const navigate = useNavigate();
  const location = useLocation();
  const { claimObj, setClaimObj, VIN } = useContext(VehicleDataContext);
  const { userID } = useContext(UserContext);
  const { token } = useContext(jwtToken);
  const [imgUploadLoading, setImgUploadLoading] = useState(false);
  const [imgUploadModel, setImgUploadModel] = useState(false);
  const [skipLoading, setSkipLoading] = useState(false);
  const [currentClaimID, setCurrentClaimID] = useState(null);

  // Get skip-related data from location state
  const claimSkiped = location.state?.claimSkiped || false;
  const isTrader = location.state?.isTrader || false;
  const pendingClaimID = location.state?.pendingClaimID || null;

  // Set current claim ID based on available data
  useEffect(() => {
    if (pendingClaimID) {
      setCurrentClaimID(pendingClaimID);
    } else if (claimObj?.ClaimID) {
      setCurrentClaimID(claimObj.ClaimID);
    }
  }, [pendingClaimID, claimObj?.ClaimID]);

  const createPendingClaimIfNeeded = async () => {
    if (claimSkiped && !currentClaimID) {
      try {
        const pendingClaim = await axios.post(
          `${process.env.REACT_APP_API_COMMON}pending-claim`,
          { VIN, userID, isTrader },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        if (pendingClaim.status === 200) {
          setClaimObj(pendingClaim.data);
          setCurrentClaimID(pendingClaim.data.ClaimID);
          return pendingClaim.data.ClaimID;
        }
      } catch (error) {
        console.error('Error creating pending claim:', error);
        await showAlert('error', '', 'Error creating pending claim!');
        throw error;
      }
    }
    return currentClaimID;
  };

  const handleUploadClick = async () => {
    if (claimSkiped && !currentClaimID) {
      try {
        setSkipLoading(true);
        const claimID = await createPendingClaimIfNeeded();
        if (claimID) {
          // Wait a moment for state to update before opening modal
          setTimeout(() => {
            setImgUploadModel(true);
            setSkipLoading(false);
          }, 100);
        } else {
          setSkipLoading(false);
        }
      } catch (error) {
        setSkipLoading(false);
      }
    } else {
      setImgUploadModel(true);
    }
  };

  const handleNext = async () => {
    if (claimSkiped) {
      try {
        setSkipLoading(true);
        const claimID = await createPendingClaimIfNeeded();
        navigate('/claim/Not%20Listed?activeStep=3', {
          state: { 
            claimSkiped: true, 
            isTrader,
            pendingClaimID: claimID 
          },
          replace: true
        });
      } catch (error) {
        navigate('/details');
      } finally {
        setSkipLoading(false);
      }
    } else {
      // Normal flow - just navigate to next step
      navigate('/claim/Not%20Listed?activeStep=3', { replace: true });
    }
  };

  // Debug log to check currentClaimID
  console.log('Debug - currentClaimID:', currentClaimID, 'claimSkiped:', claimSkiped);

  return (
    <div className="container two">
      <h5 className="claim-topic-color py-5">Upload Vehicle Image</h5>
      {imgUploadLoading || skipLoading ? (
        <ButtonSpinner />
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <FiUpload className='no-img-btn' onClick={handleUploadClick} />
        </div>
      )}
      
      <Button 
        className="right-btn"
        onClick={handleNext}
        disabled={imgUploadLoading || skipLoading}
      >
        {skipLoading ? <ButtonSpinner /> : 'Next'}
      </Button>

      <MultipleImageUpload
        imgUploadModel={imgUploadModel}
        setImgUploadModel={setImgUploadModel}
        claimID={currentClaimID}
        fetchVehicleImages={null}
        images={claimObj?.Images || []}
        setIsLoading={setImgUploadLoading}
      />
    </div>
  );
}